import { mapGetters, mapActions } from 'vuex';

import { MATCH_STATUS_ALIASES } from '@/constants/match-statuses';
import { REQUEST_LIFECYCLE } from '@/utils/request-lifecycle';
import addUTCTimeZoneDesignator from '@/utils/add-utc-time-zone-designator';

export default {
  REQUEST_LIFECYCLE,
  JOBS_STATUS_ALIASES: MATCH_STATUS_ALIASES,
  computed: {
    ...mapGetters('entities', {
      appointmentEntities: 'appointments',
    }),
    appointment () {
      const appointment = this.appointmentEntities[this.appointmentId];

      return (
        appointment && {
          ...appointment,
          start_dtm: addUTCTimeZoneDesignator(appointment.start_dtm),
          end_dtm: addUTCTimeZoneDesignator(appointment.end_dtm),
        }
      );
    },
  },
  methods: {
    ...mapActions('dashboard/job', [
      'exportAppointments',
    ]),
  },
};
